// @flow
import appConfig from './app'

export default {
  ...appConfig,
  baseURL: process.env.NODE_ENV === 'development' ? window.location.href : 'https://foxford.ru',
  crossDomain: true,
  withCredentials: true,
}
